import React from 'react';

interface SummaryFieldProps {
  label: string;
  value: React.ReactNode;
}

export const SummaryField: React.FC<SummaryFieldProps> = ({ label, value }) => (
  <div className="flex flex-col">
    <span className="text-[11px] text-gray-500 font-semibold uppercase tracking-wide">{label}</span>
    <span className="text-sm text-gray-800">{value || '—'}</span>
  </div>
);

interface AdminSummaryCardProps {
  children: React.ReactNode;
  className?: string;
}

export const AdminSummaryCard: React.FC<AdminSummaryCardProps> = ({ children, className = '' }) => (
  <div className={`bg-gray-50 border border-gray-200 rounded-lg p-4 mb-6 ${className}`}>
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-x-6 gap-y-3">
      {children}
    </div>
  </div>
);

interface AdminDetailsHeaderProps {
  title: React.ReactNode;
  onClose: () => void;
  onRefresh?: () => void;
  refreshing?: boolean;
  rightExtra?: React.ReactNode;
}

export const AdminDetailsHeader: React.FC<AdminDetailsHeaderProps> = ({
  title,
  onClose,
  onRefresh,
  refreshing,
  rightExtra,
}) => (
  <div className="flex justify-between items-center mb-4">
    <h1 className="text-storyblue text-lg md:text-2xl font-bold">{title}</h1>
    <div className="flex gap-2 items-center">
      {rightExtra}
      {onRefresh && (
        <button
          onClick={onRefresh}
          disabled={refreshing}
          className="inline-flex items-center gap-1 bg-gray-100 hover:bg-gray-200 text-gray-700 text-sm font-medium rounded px-3 py-2 border border-gray-300 disabled:opacity-50 cursor-pointer"
          title="Refresh"
        >
          ↻ Refresh
        </button>
      )}
      <button
        className="bg-gray-200 text-gray-700 font-medium px-4 py-2 rounded-md shadow hover:bg-gray-300 transition"
        onClick={onClose}
      >
        Close
      </button>
    </div>
  </div>
);
